import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectButtonComponent } from './select-button.component';

@NgModule({
  imports: [CommonModule],
  exports: [SelectButtonComponent],
  declarations: [SelectButtonComponent],
  providers: [],
})
export class SelectButtonModule {
}
